import { Redirect, Route, RouteProps, useLocation } from "react-router-dom";
import { clearSession, isJwtTokenValid } from "../utils/helpers";
import React, { lazy, useEffect } from "react";
import { Forbidden } from "./pages/Forbidden/Loadable";
import authService from "services/authService";
import { useSnackbar } from "notistack";

export type ProtectedRouteProps = {
  authenticationPath: string;
  // verificationPath: string;
  roles?: string[];
} & RouteProps;

export default function ProtectedRoute({
  roles,
  authenticationPath,
  // verificationPath,
  ...routeProps
}: ProtectedRouteProps) {
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  
  // Use authService for more robust token validation
  const isValid = authService.isTokenValid();
  const tokenRoles = authService.getUserRoles();
  
  useEffect(() => {
    // Check token validity on route change
    if (!isValid) {
      const token = authService.getAuthToken();
      if (token) {
        // Token exists but expired
        enqueueSnackbar("Your session has expired. Please login again.", {
          variant: "warning"
        });
      }
    }
  }, [location.pathname, isValid]);
  
  if (isValid) {
    // Check role-based access
    if (roles && roles.length > 0) {
      const roleIntersection = roles.filter((value: string) =>
        tokenRoles.includes(value)
      );
      if (roleIntersection.length === 0) {
        const { component, ...rest } = routeProps;
        return <Route component={Forbidden} {...rest} />;
      }
    }
    return <Route {...routeProps} />;
  } else {
    // Token is invalid or expired
    const baseURL = process.env.REACT_APP_WORDPRESS_BASE_URI || "";
    
    // Clear auth data and redirect
    authService.clearAuthToken();
    
    // Small delay to show the message
    setTimeout(() => {
      window.location.replace(baseURL);
    }, 1000);
    
    return <Redirect to={{ pathname: authenticationPath }} />;
  }
}
